import type { Asset, AssetCreate, AssetUpdate, AssetType } from "@iso27001/shared";
import { apiFetch } from "./client.js";
import type { AuditEntry } from "../components/AuditHistoryModal.js";

interface ListResp<T> { items: T[]; total: number; page: number; pageSize: number; }

export const assetsApi = {
  list: (params: { q?: string; type?: AssetType; page?: number; pageSize?: number } = {}): Promise<ListResp<Asset>> => {
    const qs = new URLSearchParams();
    if (params.q) qs.set("q", params.q);
    if (params.type) qs.set("type", params.type);
    if (params.page) qs.set("page", String(params.page));
    if (params.pageSize) qs.set("pageSize", String(params.pageSize));
    const url = `/api/assets${qs.toString() ? `?${qs}` : ""}`;
    return apiFetch<ListResp<Asset>>(url);
  },
  get: (id: number): Promise<Asset> => apiFetch<Asset>(`/api/assets/${id}`),
  create: (body: AssetCreate): Promise<Asset> =>
    apiFetch<Asset>("/api/assets", { method: "POST", body: JSON.stringify(body) }),
  update: (id: number, body: AssetUpdate): Promise<Asset> =>
    apiFetch<Asset>(`/api/assets/${id}`, { method: "PATCH", body: JSON.stringify(body) }),
  remove: (id: number): Promise<null> =>
    apiFetch<null>(`/api/assets/${id}`, { method: "DELETE" }),
  audit: (id: number): Promise<{ items: AuditEntry[] }> =>
    apiFetch<{ items: AuditEntry[] }>(`/api/assets/${id}/audit`),
};
